import { createClient } from '@supabase/supabase-js';

// Get environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Debug: Log what we're getting from environment variables
console.log('Environment variables debug:');
console.log('REACT_APP_SUPABASE_URL:', supabaseUrl);
console.log('REACT_APP_SUPABASE_ANON_KEY:', supabaseAnonKey ? 'Present' : 'Missing');
console.log('All env vars:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP')));

// Validate environment variables
if (!supabaseUrl || supabaseUrl === 'your-supabase-url') {
  console.error('Environment variables available:', process.env);
  throw new Error(
    'Missing REACT_APP_SUPABASE_URL environment variable. ' +
    'Please check your .env file and make sure it contains a valid Supabase URL. ' +
    'Current value: ' + supabaseUrl
  );
}

if (!supabaseAnonKey || supabaseAnonKey === 'your-supabase-anon-key') {
  throw new Error(
    'Missing REACT_APP_SUPABASE_ANON_KEY environment variable. ' +
    'Please check your .env file and make sure it contains a valid Supabase anon key.'
  );
}

// Validate URL format
if (!supabaseUrl.startsWith('https://') || !supabaseUrl.includes('.supabase.co')) {
  throw new Error(
    'Invalid REACT_APP_SUPABASE_URL format. ' +
    'Expected format: https://your-project-id.supabase.co'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);